(() => {
  const initialize = root => {
    root.querySelectorAll('[data-hf-purchase]').forEach(purchase => {
      if (purchase.dataset.hfPurchaseReady) return;
      purchase.dataset.hfPurchaseReady = 'true';
      const select = purchase.querySelector('[data-hf-variant-select]');
      const options = purchase.querySelector('[data-hf-variant-options]');
      if (select && options) {
        options.hidden = false;
        select.hidden = true;
        const label = purchase.querySelector('#hf-pdp-variant-label');
        if (label) label.removeAttribute('for');
        options.querySelectorAll('[data-hf-variant]').forEach(button => {
          button.addEventListener('click', () => {
            if (button.dataset.hfVariant === select.value) return;
            select.value = button.dataset.hfVariant;
            options.querySelectorAll('[data-hf-variant]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
            select.dispatchEvent(new Event('change', { bubbles: true }));
          });
        });
      }
      const input = purchase.querySelector('#quantity');
      const buttons = [...purchase.querySelectorAll('[data-hf-quantity]')];
      if (!input) return;
      const minimum = () => Number(input.min) || 1;
      const maximum = () => input.max ? Number(input.max) : Infinity;
      const sync = () => buttons.forEach(button => {
        button.disabled = input.disabled || (Number(button.dataset.hfQuantity) < 0 ? Number(input.value) <= minimum() : Number(input.value) >= maximum());
      });
      buttons.forEach(button => button.addEventListener('click', () => {
        if (input.disabled) return;
        const direction = Number(button.dataset.hfQuantity);
        const current = Number(input.value);
        if (!Number.isFinite(current) || current < minimum()) input.value = String(minimum());
        try { direction > 0 ? input.stepUp() : input.stepDown(); } catch { input.value = String(Math.max(minimum(), Math.min(maximum(), (current || minimum()) + direction))); }
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
        sync();
      }));
      input.addEventListener('input', sync);
      input.addEventListener('change', () => {
        const step = Number(input.step) || 1;
        const value = Number(input.value);
        const snapped = minimum() + Math.round(((Number.isFinite(value) ? value : minimum()) - minimum()) / step) * step;
        input.value = String(Math.max(minimum(), Math.min(maximum(), snapped)));
        sync();
      });
      sync();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

